<template>
  <div id="ag-grid-demo">
    <vx-card>
        <div class="flex">
          <div class="md:mb-5 ml-6" style="min-width: 200px">
            <label class="vs-input--label">START DATE</label>
            <div>
              <flat-pickr
                v-model="start_time"
                :config="{
                  ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i',
                  defaultDate: new Date().setHours(0, 0, 0),
                }"
                @input="SetDatetimeForStart"
              />
            </div>
          </div>
          <div class="md:mb-5 ml-6" style="min-width: 200px">
            <label class="vs-input--label">END DATE</label>
            <div>
              <flat-pickr
                v-model="end_time"
                :config="{
                ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i',
                  defaultDate: new Date().setHours(23, 59, 59),
                }"

                @input="SetDatetimeForEnd"
              />
            </div>
          </div>
<!--          <div class="smsc-navigation__col ml-6 sent-btn">
            <vs-button @click="GetList()">Sent</vs-button>
          </div>-->
          <div class="md:mb-5 ml-6">
            <label class="vs-input--label">Caller ID</label>
              <vs-input/>
          </div>
          <div class="md:mb-5 ml-6">
            <label class="vs-input--label">Destination Number</label>
              <vs-input/>
          </div>
        </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0">
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'

// Packages
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer components
// import CellRendererActions from './cell-renderer/CellRendererActions'
// import CellRendererStatus from './cell-renderer/CellRendererStatus'

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,
    flatPickr
    //Cell Renderer components
    // CellRendererActions,
    // CellRendererStatus
  },
  data() {
    return {
      start_time:  new Date().setHours(0, 0, 0),
      end_time:  new Date().setHours(23, 59, 59),
      // table header value
      columnDefs: [
        {
          headerName: 'Time',
          field: 'time',
          minWidth: 250,
        },
        {
          headerName: 'Src Num',
          field: 'src_num',
          minWidth: 200
        },
        {
          headerName: 'Dest Num',
          field: 'dest_num',
          minWidth: 200
        },
        {
          headerName: 'Content',
          field: 'content',
          minWidth: 150
        },
        {
          headerName: 'Cost',
          field: 'cost',
          minWidth: 100
        },
        {
          headerName: 'Status',
          field: 'status',
          minWidth: 120
        },
        {
          headerName: 'Reason',
          field: 'reason',
          minWidth: 150
        },
      ],

      // Cell Renderer components
      components: {
    //     CellRendererActions,
    //     CellRendererStatus
      },
      searchProduct: ''
    }
  },
  watch: {
    start_time() {
      setTimeout(()=> {
        this.GetList()
      },100)
    },
    end_time() {
      setTimeout(()=> {
        this.GetList()
      },100)
    }
  },
  created() {
    this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
    this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
    this.GetList()
  },
  methods: {
    SetDatetimeForStart() {
      this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
    },
    SetDatetimeForEnd(){
      this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
    },
    GetList() {
      this.$vs.loading()
      this.$store.dispatch('reseller/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
        reseller_name: this.searchProduct + "*"
      })
      .then(res => {
        this.list = res.items.map(this.TransformReseller)
        this.total = res.total
      })
      .catch()
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    TransformReseller(item) {
      return {
        refreshData: this.GetList,
        time: format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
        status: item.status
      }
    },
    // onQuickFilterChanged() {
    //   this.GetList()
    // },
  }
}
</script>
<style>
    .filter_input_reseller{
        padding: 17px;
        padding-left: 55px;
        width: 300px;
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
    }
    .has-search .form-control-reseller-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 35px;

        margin-top: 20px;
    }
    .sent-btn {
      margin-top: 23px;
    }
</style>
